




































































import { computed, defineComponent } from '@nuxtjs/composition-api';
import { useAlerts } from '~/features/alerts';
import { useEventBus } from '~/features/events';
import { useI18n } from '~/features/i18n';
import { ProductData } from '~/features/product';
import { useAddProductToCartContext } from '~/features/productAddToCart';
import { ProductContext, useProductContext, useProductGiftWrappingContext } from '~/features/productContext';
import { EnteredOptionInput, CustomizableOptionInput } from '~/graphql-types.gen';
// import { isWeightedItem } from '~/utils/product';

/**
 *
 * helper functions
 */

/**
 * shouldn't display add to cart button
 */
function shouldShowAddToCartButton(product: ProductContext): boolean {
  if (product.type === 'SimpleProduct' && !product.parentSku) {
    return false;
  }

  if (product.type === 'ConfigurableProduct' && product.parentSku) {
    return false;
  }

  if ((product.type === 'SimpleProduct' && product.parentSku) || product.type === 'MageWorxGiftCards') {
    return false;
  }

  return true;
}

/**
 * ACTIVE: update quantity control upon changing the quantity
 * PASSIVE: have to click add to cart to apply
 *
 */
function qtyControlType(product: ProductContext): 'ACTIVE' | 'PASSIVE' {
  if (product.type === 'SimpleProduct' || product.type === 'MageWorxGiftCards') {
    return 'ACTIVE';
  }

  if (product.type === 'ConfigurableProduct' && product.parentSku) {
    return 'ACTIVE';
  }

  return 'PASSIVE';
}

function shouldDisableQtyButton(product: ProductData): boolean {
  if (product.type === 'GroupedProduct') {
    return true;
  }
  return false;
}

/**
 *
 * Based on the provided design
 *
 * case 1: for weighted items products hide add to cart and display add to cart aggressive item
 * case 2: for grouped items disable quantity controllers and show add to cart only
 * case 3: for bundle items show passive quantity controllers and add to cart only
 */
export default defineComponent({
  props: {
    disableAddToCart: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { product } = useProductContext();
    const { giftWrappingComment } = useProductGiftWrappingContext();
    const { quantity, addToCart: add } = useAddProductToCartContext();
    const { error } = useAlerts();
    const { emit } = useEventBus();
    const { t } = useI18n();

    async function addToCart() {
      try {
        await add();
        emit('ITEM_ADDED', product.value);
      } catch (err) {
        if (/the requested qty is not available/i.test((err as Error).message)) {
          error(t('qtyUnavailable', [product.value?.name]) as string);
          return;
        }

        if (
          /Product that you are trying to add is not available/i.test((err as Error).message) ||
          /Some of the products are out of stock/i.test((err as Error).message)
        ) {
          error(t('outOfStockError', [product.value?.name]) as string);
        }
      }
    }

    return {
      product,
      addToCart,
      quantity,
      showAddToCartButton: computed(() => {
        return shouldShowAddToCartButton(product.value);
      }),
      qtyControlState: computed(() => qtyControlType(product.value)),
      disableControlState: computed(() => shouldDisableQtyButton(product.value)),
      options: computed<{
        entered_options?: Array<EnteredOptionInput>;
        customizable_options?: Array<CustomizableOptionInput>;
      }>(() => {
        return {
          ...(product.value.simpleGiftBoxOptionId
            ? {
                entered_options: [
                  {
                    uid: product.value.simpleGiftBoxOptionId,
                    value: giftWrappingComment.value || 'N/A',
                  },
                ],
              }
            : {}),
          ...(product.value.configurableGiftBoxOptionId
            ? {
                customizable_options: [
                  {
                    id: product.value.configurableGiftBoxOptionId,
                    value_string: giftWrappingComment.value || 'N/A',
                  },
                ],
              }
            : {}),
        };
        // return product.value.giftBoxOptionId
        //   ? [
        //       {
        //         id: product.value.giftBoxOptionId,
        //         value: giftWrappingComment.value || 'N/A',
        //       },
        //     ]
        //   : [];
      }),
    };
  },
});
